// extracted by mini-css-extract-plugin
export default {"deviceCreate":"DeviceCreate_deviceCreate__cl5ET","formContainer":"DeviceCreate_formContainer__gjg23","paperContainer":"DeviceCreate_paperContainer__X8eGV"};